/* BEINGFIT Theme JS v5 */
(function () {
  'use strict';

  /* ── Mobile Nav ────────────────────────────── */
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobileNav');
  var navClose  = document.getElementById('mobileNavClose');

  if (hamburger && mobileNav && navClose) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    navClose.addEventListener('click', closeMobileNav);
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) closeMobileNav();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobileNav();
    });
  }
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── Cart count sync ───────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ── Collection page: Ajax Add to Cart ─────── */
  document.querySelectorAll('.product-card form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.btn-cart');
      if (!btn) return;
      var orig = btn.textContent;
      btn.textContent = '✓ 追加済み';
      btn.style.background = '#1a7a1a';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      }).then(function (res) {
        return res.ok ? res.json() : Promise.reject();
      }).then(function () {
        updateCartCount();
        setTimeout(function () {
          btn.textContent = orig;
          btn.style.background = '';
        }, 2200);
      }).catch(function () {
        btn.textContent = 'エラー';
        setTimeout(function () { btn.textContent = orig; btn.style.background = ''; }, 2000);
      });
    });
  });

  /* ── Product Page ──────────────────────────── */
  var productForm = document.getElementById('product-form');
  if (!productForm) return; // not on product page

  var variants       = JSON.parse(document.getElementById('product-variants-json').textContent || '[]');
  var variantIdInput = document.getElementById('variantId');
  var priceDisplay   = document.getElementById('priceDisplay');
  var compareDisplay = document.getElementById('compareDisplay');
  var addCartBtn     = document.getElementById('addToCartBtn');
  var cartFeedback   = document.getElementById('cartFeedback');
  var qtyInput       = document.getElementById('qtyInput');

  /* Image switcher */
  window.switchImage = function (src, thumb) {
    var img = document.getElementById('mainImg');
    if (img) {
      img.style.opacity = '0.5';
      img.src = src;
      img.onload = function () { img.style.opacity = '1'; };
    }
    document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    if (thumb) thumb.classList.add('active');
  };

  /* Quantity */
  window.changeQty = function (delta) {
    if (!qtyInput) return;
    var val = parseInt(qtyInput.value || 1) + delta;
    qtyInput.value = Math.min(Math.max(val, 1), 99);
  };

  /* Variant selection */
  window.selectOption = function (btn, optionIndex) {
    var group = btn.closest('.option-btns');
    group.querySelectorAll('.option-btn').forEach(function (b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    syncVariant();
  };

  function getSelectedOptions() {
    var opts = [];
    document.querySelectorAll('.option-btns').forEach(function (group) {
      var sel = group.querySelector('.option-btn.selected');
      opts.push(sel ? sel.getAttribute('data-value') : null);
    });
    return opts;
  }

  function syncVariant() {
    var selected = getSelectedOptions();
    var match = variants.find(function (v) {
      return selected.every(function (opt, i) {
        return !opt || v['option' + (i + 1)] === opt;
      });
    });

    if (!match) return;

    if (variantIdInput) variantIdInput.value = match.id;

    /* Price */
    if (priceDisplay) priceDisplay.textContent = formatMoney(match.price);
    if (compareDisplay) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareDisplay.textContent = formatMoney(match.compare_at_price);
        compareDisplay.style.display = '';
      } else {
        compareDisplay.textContent = '';
        compareDisplay.style.display = 'none';
      }
    }

    /* Availability */
    if (addCartBtn) {
      if (match.available) {
        addCartBtn.disabled = false;
        addCartBtn.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> カートに追加 / ADD TO CART';
        addCartBtn.style.background = '';
      } else {
        addCartBtn.disabled = true;
        addCartBtn.textContent = '売り切れ / SOLD OUT';
        addCartBtn.style.background = '#333';
      }
    }

    /* Mark unavailable options */
    document.querySelectorAll('.option-btns').forEach(function (group, gi) {
      group.querySelectorAll('.option-btn').forEach(function (btn) {
        var testOpts = getSelectedOptions();
        testOpts[gi] = btn.getAttribute('data-value');
        var exists = variants.some(function (v) {
          return v.available && testOpts.every(function (opt, i) {
            return !opt || v['option' + (i + 1)] === opt;
          });
        });
        btn.classList.toggle('unavailable', !exists && !btn.classList.contains('selected'));
      });
    });
  }

  /* Ajax Add to Cart */
  productForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!addCartBtn || addCartBtn.disabled) return;
    var origHTML = addCartBtn.innerHTML;
    addCartBtn.innerHTML = '✓ カートに追加しました！';
    addCartBtn.classList.add('success');

    if (cartFeedback) { cartFeedback.textContent = ''; cartFeedback.className = 'cart-feedback'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(productForm))
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'error'); });
      return res.json();
    }).then(function () {
      updateCartCount();
      if (cartFeedback) {
        cartFeedback.className = 'cart-feedback ok';
        cartFeedback.textContent = '✓ カートに追加しました！ / Added to cart!';
      }
      setTimeout(function () {
        addCartBtn.innerHTML = origHTML;
        addCartBtn.classList.remove('success');
        if (cartFeedback) { cartFeedback.textContent = ''; cartFeedback.className = 'cart-feedback'; }
      }, 3000);
    }).catch(function (err) {
      addCartBtn.innerHTML = origHTML;
      addCartBtn.classList.remove('success');
      if (cartFeedback) {
        cartFeedback.className = 'cart-feedback err';
        cartFeedback.textContent = err.message || 'エラーが発生しました。もう一度お試しください。';
      }
    });
  });

  /* Tabs */
  window.switchTab = function (id, btn) {
    document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
    document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
    var panel = document.getElementById('tab-' + id);
    if (panel) panel.classList.add('active');
    if (btn) btn.classList.add('active');
  };

  /* Format money */
  function formatMoney(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }

  /* Initial sync */
  syncVariant();

})();
